export default "__VITE_ASSET__BYjG81MT__"